import { apiKeyAuth, apiKeyAuthItems } from "../apiKeyAuthMethod";
import { caCertificateItem, defineConnector } from "../types";
import logo from "./logo.svg";

export const apiKey = defineConnector({
  identifier: "apiKey",
  name: "API key",
  tagLine: "Connect to anything",
  logo,
  protocol: "http",
  tags: ["custom"],
  defaultUrlPattern: () => ".*",
  customizeStepHandledInline: true,
  auth: apiKeyAuth,
  steps: [
    {
      title: "Name your connection",
      items: [
        {
          kind: "input",
          label: "Name",
          placeholder: "e.g. Stripe, Twilio",
          target: { kind: "connectedApp", field: "name" },
        },
        {
          kind: "url-pattern",
          placeholder: "api.example.com",
          target: { kind: "connectedApp", field: "urlPattern" },
        },
      ],
    },
    {
      title: "Authenticate",
      items: apiKeyAuthItems({ apiKeyPlaceholder: "secret" }),
    },
    {
      title: "Verify the connection (optional)",
      items: [
        caCertificateItem,
        {
          kind: "test-url",
          label: "Test URL",
          placeholder: "https://api.example.com/user",
          helperText: "Leave blank to skip testing.",
          urlTarget: { kind: "configuration", field: "testUrl" },
          methodTarget: { kind: "configuration", field: "testMethod" },
        },
      ],
    },
  ],
  connectionTest: {
    protocol: "http",
    request: ({ testUrl, testMethod }) => ({
      url: testUrl ?? "",
      method: testMethod === "POST" ? "POST" : "GET",
    }),
  },
});
